// 教师团队
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import cls from 'classnames';
import { PC, Mobile } from '@wukong/haomao';
import { MyContext } from '../../../../config/context-manager';
import Title from '../Title';
import styles from './style.module.scss';

interface PointItemProps {
  label: string;
  idx: number;
}

const PointItem = ({ label, idx }: PointItemProps) => {
  return (
    <div className={cls(styles.specilBox, styles[`specil-box-${idx + 1}`])}>
      <span dangerouslySetInnerHTML={{ __html: label }} />
    </div>
  );
};

const Teachers = () => {
  const { t } = useTranslation('mathSpecialty');
  const teachersBoxData = [t('教师团队-特点-1'), t('教师团队-特点-2'), t('教师团队-特点-3'), t('教师团队-特点-4')];
  return (
    <>
      <PC>
        <div>
          <div className={styles.avatorBox}>
            <Image
              src="/images/chinese-math-class/math/specialty/team-teachers-avator.png"
              layout="fill"
              alt="悟空数学特色 教师团队"
            />
          </div>
        </div>
      </PC>
      <Mobile>
        <div>
          <div className={styles.avatorBox}>
            <Image
              src="/images/chinese-math-class/math/specialty/team-teachers-avator-m.png"
              layout="fill"
              alt="悟空数学特色 教师团队"
            />
          </div>
        </div>
      </Mobile>
      {teachersBoxData.map((item, index) => (
        <PointItem key={item} label={item} idx={index} />
      ))}
    </>
  );
};

const Team = () => {
  const { t } = useTranslation('mathSpecialty');
  const { locale } = useContext(MyContext);
  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div>
          <div className={styles.bg}>
            <Image src="/images/chinese-math-class/math/specialty/team-bg-pc.png" layout="fill" alt="" />
          </div>
          <div className={styles.mbg}>
            <Image src="/images/chinese-math-class/math/specialty/team-bg-pc-m.png" layout="fill" alt="" />
          </div>
        </div>
      </PC>
      <Mobile>
        <div>
          <div className={styles.bg}>
            <Image src="/images/chinese-math-class/math/specialty/team-bg-m.png" layout="fill" alt="" />
          </div>
        </div>
      </Mobile>

      <div className={styles.teachersImgBox}>
        <Teachers />
      </div>
      <div className={styles.content}>
        <Title theme="allWhite" className={styles.teamTitle}>
          {t('教师团队-标题')}
        </Title>
        <h4>{t('教师团队-副标题')}</h4>
        <p>{t('教师团队-内容')}</p>
        <p className={styles.p}>{t('教师团队-内容-2')}</p>
      </div>
    </section>
  );
};

export default Team;
